import { Reveal, Label } from "./Motion";

const PLANS = ["Reset", "Momentum", "Elevate"];

const ROWS = [
  { label: "Primary Goal", values: ["Understand", "Improve", "Transform"] },
  { label: "Business Assessment", values: ["Yes", "Yes", "Yes"] },
  { label: "Financial Analysis", values: ["Yes", "Yes", "Advanced"] },
  { label: "Customer Analysis", values: ["Yes", "Yes", "Advanced"] },
  { label: "Sales & Marketing Analysis", values: ["Yes", "Yes", "Advanced"] },
  { label: "Operations Analysis", values: ["Yes", "Yes", "Advanced"] },
  { label: "Technology Assessment", values: ["Yes", "Yes", "Advanced"] },
  { label: "AI Opportunity Assessment", values: ["Yes", "Yes", "Advanced"] },
  { label: "KPI Development", values: ["Foundation", "Full", "Advanced"] },
  { label: "Strategy", values: ["Basic", "Full", "Advanced"] },
  { label: "Implementation", values: ["Limited", "Yes", "Extensive"] },
  { label: "AI / Automation", values: ["Identify", "Implement", "Advanced"] },
  { label: "Forecasting", values: ["Basic", "Yes", "Advanced"] },
  { label: "Executive Advisory", values: ["No", "Monthly", "Ongoing"] },
  { label: "Strategic Planning", values: ["No", "Yes", "Advanced"] },
  { label: "Best For", values: ["Businesses seeking clarity", "Businesses ready to improve", "Businesses ready to scale"] },
];

function Cell({ v }) {
  if (v === "No") return <span className="text-black/25">—</span>;
  const strong = ["Advanced", "Extensive", "Ongoing", "Full", "Transform"].includes(v);
  return (
    <span className={strong ? "text-[#a3823f] font-medium" : "text-[#1e3d3a]"}>{v}</span>
  );
}

export default function PackageComparison() {
  return (
    <section data-testid="package-comparison" className="relative bg-[#f4f1e9] py-24 sm:py-32 border-t border-black/10">
      <div className="mx-auto max-w-6xl px-6">
        <Reveal>
          <Label>Package comparison</Label>
          <h2 className="mt-6 font-head text-4xl sm:text-5xl font-light tracking-tighter text-[#1e3d3a]">
            Compare Every<br />
            <span className="text-black/40">Level of Engagement.</span>
          </h2>
        </Reveal>

        {/* Desktop / tablet table */}
        <Reveal delay={0.1}>
          <div className="mt-14 hidden md:block overflow-hidden rounded-2xl border border-black/10 bg-white">
            <table className="w-full text-sm" data-testid="comparison-table">
              <thead>
                <tr className="border-b border-black/10">
                  <th className="text-left font-normal text-[10px] uppercase tracking-[0.22em] text-black/40 px-6 py-5 w-[34%]"></th>
                  {PLANS.map((p, i) => (
                    <th key={p} className={`text-left font-head text-lg font-normal px-6 py-5 ${i === 1 ? "bg-[#1e3d3a]/[0.04] text-[#1e3d3a]" : "text-[#1e3d3a]"}`}>
                      {p}
                      {i === 1 && <span className="ml-2 align-middle text-[9px] uppercase tracking-[0.18em] text-[#a3823f]">Most engaged</span>}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {ROWS.map((r, ri) => (
                  <tr key={r.label} className={`border-b border-black/[0.06] last:border-0 ${ri % 2 ? "bg-[#faf8f2]" : "bg-white"}`}>
                    <td className="px-6 py-3.5 text-black/55">{r.label}</td>
                    {r.values.map((v, ci) => (
                      <td key={ci} className={`px-6 py-3.5 ${ci === 1 ? "bg-[#1e3d3a]/[0.03]" : ""}`}>
                        <Cell v={v} />
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Reveal>

        {/* Mobile stacked cards */}
        <div className="mt-12 md:hidden space-y-6">
          {PLANS.map((p, ci) => (
            <Reveal key={p} delay={ci * 0.06}>
              <div className="rounded-2xl border border-black/10 bg-white p-5">
                <h3 className="font-head text-xl text-[#1e3d3a] mb-3">{p}</h3>
                <dl className="divide-y divide-black/[0.06]">
                  {ROWS.map((r) => (
                    <div key={r.label} className="flex items-center justify-between gap-4 py-2.5">
                      <dt className="text-xs text-black/50">{r.label}</dt>
                      <dd className="text-sm text-right"><Cell v={r.values[ci]} /></dd>
                    </div>
                  ))}
                </dl>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
